import { render, staticRenderFns } from "./IconTransfers.vue?vue&type=template&id=4e9a4027"
import script from "./IconTransfers.vue?vue&type=script&lang=ts"
export * from "./IconTransfers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports